export const INITIALIZE = "INITIALIZE";
export const ADD_ISSUE = "ADD_ISSUE";
export const DELETE_ISSUE = "DELETE_ISSUE";
export const EDIT_ISSUE = "EDIT_ISSUE";
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const SIGNUP_USER = "SIGNUP_USER";